import type { AuthenticatorTransportFuture } from "@simplewebauthn/browser";
import { LANGUAGES, THEME_MODE_TYPE, WEB3AUTH_NETWORK_TYPE } from "@web3auth/auth";

import { LOGIN_CONNECTIONS, LOGIN_FLOW, TOAST_TYPES } from "./constants";

export interface IVerificationData {
  data: {
    state: string;
    access_token: string;
    id_token: string;
  };
}

export const EMAIL_FLOW = {
  LINK: "link",
  CODE: "code",
} as const;

export type EMAIL_FLOW_TYPE = (typeof EMAIL_FLOW)[keyof typeof EMAIL_FLOW];

export interface WhiteLabelParams {
  name?: string;
  url?: string;
  language?: keyof typeof LANGUAGES;
  theme?: Record<string, string>;
  logo?: string;
  mode?: THEME_MODE_TYPE;
}

export interface IErrorState {
  message: string;
  subMessage?: string;
  errorCode?: string;
}

export interface IVerifyResponse {
  success: boolean;
  error: boolean;
  message: string;
}

export type PASSWORDLESS_CONNECTIONS_TYPE = (typeof LOGIN_CONNECTIONS)[keyof typeof LOGIN_CONNECTIONS];

export interface CodeInitiateRequestBodyParams {
  client_id: string;
  connection: string;
  login_hint: string;
  web3auth_client_id: string;
  tracking_id?: string;
  whitelabel?: WhiteLabelParams;
  version?: string;
  network?: string;
  flow_type?: EMAIL_FLOW_TYPE;
  captcha_token?: string;
}

export interface CodeVerifyRequestBodyParams {
  client_id: string;
  login_hint: string;
  code: string;
  connection: PASSWORDLESS_CONNECTIONS_TYPE;
  tracking_id: string;
  version?: string;
  network?: string;
  flow_type?: EMAIL_FLOW_TYPE;
}

export interface ValidatePhoneNumberApiResponse {
  success: boolean;
  parsed_number: string;
  country_flag: string;
}

export type PASSKEYS_FLOW_TYPE = (typeof LOGIN_FLOW)[keyof typeof LOGIN_FLOW];

export type PasskeysSessionData = {
  verifier_id: string;
  signature: string;
  clientDataJSON: string;
  authenticatorData: string;
  publicKey: string;
  challenge: string;
  rpOrigin: string;
  rpId: string;
  credId: string;
  transports: AuthenticatorTransportFuture[];
  username: string;
};

export interface BaseStateParams {
  client: string;
  currentAuthConnection: string;
  popupWindow: string;
  keyMode: string;
  whiteLabel: string;
  disableAlwaysSkip: string;
  loginId: string;
  version: string;
  sessionNamespace: string;
}

export interface PasskeysCustomAuthStateParams extends BaseStateParams {
  authenticatorAttachment: string;
  oAuthUserId: string;
  oAuthConnectionId: string;
  authToken: string;
  address: string;
  dappUrl: string;
  dappName: string;
  isCustomAuthConnectionId: string;
  loginFlow: PASSKEYS_FLOW_TYPE;
  passkeysHostUrl?: string;
  oAuthConnection: string;
  email: string;
  name: string;
  network: WEB3AUTH_NETWORK_TYPE;
}

export type TOAST_TYPES_TYPE = (typeof TOAST_TYPES)[keyof typeof TOAST_TYPES];
